import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./navbar";
import AddWhatsAppKeysPopup from "./pages/WhatsAppKeys/AddWhatsAppKeysPopup";
import WhatsAppKeyContext from "../context/WhatsAppKeyContext/WhatsAppKeyContext";

const MainHeader = (props) => {
  const { windowSize, setMainDivSidebar, maindivSidebar } = props;

  return (
    <>
      <Navbar
        windowSize={windowSize}
        setMainDivSidebar={setMainDivSidebar}
        maindivSidebar={maindivSidebar}
      />

      <Outlet />
    </>
  );
};

export default MainHeader;
